import * as React from 'react'
import Lottie from 'react-lottie'
import styled from 'styled-components'
import * as animationData from './json-animation/lisalogoLOOP.json'

/**
 * Lisa logo, animates or reverses on click as an Easter egg
 *
 * source: https://github.com/dynasty-com/web-marketing/blob/master/src/components/AnimatedLogo/index.js
 */
export default class LogoAnimated extends React.Component<
  Record<string, never>,
  { isStopped: boolean; isPaused: boolean; speed: number; direction: number }
> {
  constructor(props: Record<string, never> | Readonly<Record<string, never>>) {
    super(props)
    this.state = {
      isStopped: true,
      isPaused: false,
      speed: 1,
      direction: 1,
    }

    this.handleClick = this.handleClick.bind(this)
  }

  handleClick() {
    console.log('Clicked Lisa Logo')
    if (!this.state.isStopped) {
      this.setState({ direction: this.state.direction * -1 })
    }
    this.setState({ isStopped: false })
  }

  render() {
    const { isStopped, isPaused, direction, speed } = this.state

    const options = {
      loop: false,
      autoplay: false,
      animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
      isClickToPauseDisabled: true,
    }

    const handleReset = () => {
      this.setState({ isStopped: !isStopped })
    }

    return (
      // eslint-disable-next-line @typescript-eslint/unbound-method
      <LogoAnimatedWrapper onClick={this.handleClick}>
        <LogoMark>
          <Player>
            <Lottie
              options={options}
              height={72}
              width={65}
              isStopped={isStopped}
              isPaused={isPaused}
              speed={speed}
              direction={direction}
              eventListeners={[
                {
                  eventName: 'complete',
                  callback: handleReset,
                },
              ]}
            />
          </Player>
        </LogoMark>
        <LisaTypemark className="typemark" src="/leasing/assets/typemark.svg" alt="Lisa Typemark" />
      </LogoAnimatedWrapper>
    )
  }
}

/**
 * The pure white "Lisa", displayed to the right of the animation
 */
const LisaTypemark = styled.img`
  width: 72px;
  height: 40px;
  position: relative;
  left: -14px;
  object-fit: contain;
  filter: none !important;
`

/**
 * Contains the whole animation and text
 */
const LogoAnimatedWrapper = styled.div`
  display: inline-flex;
  width: fit-content;
  transition: 1s all ease-in-out !important;
`

/**
 * Holds the colored logomark, which animates
 */
const LogoMark = styled.div`
  width: 43px;
  height: 48px;
  overflow: hidden;
`

/**
 * Lottie player, which needs to be positioned in-frame
 */
const Player = styled.div`
  position: relative;
  top: -16px;
  left: -16px;
`
